import { Radar } from "lucide-react";
import { cn } from "@/lib/utils";

export function Logo({ className, showText = true, light = false }) {
  return (
    <div className={cn("flex items-center gap-2.5", className)} data-testid="brand-logo">
      <div className="relative grid place-items-center w-9 h-9 rounded-xl bg-gradient-to-br from-blue-600 to-indigo-500 shadow-lg shadow-blue-500/25">
        <Radar className="w-5 h-5 text-white" strokeWidth={2.2} />
      </div>
      {showText && (
        <div className="leading-none">
          <span className={cn("font-heading font-extrabold text-lg tracking-tight", light ? "text-white" : "text-slate-900")}>
            Respondia
          </span>
          <span className={cn("block font-heading font-semibold text-[10px] tracking-wide uppercase mt-0.5 whitespace-nowrap", light ? "text-blue-200" : "text-blue-600")} data-testid="brand-tagline">Pilotage &amp; Performance</span>
        </div>
      )}
    </div>
  );
}
